export function useFetchAllFieldOfLaws() {
  return useQuery(queries().fieldOfLaws.all);
}
